import {
  Calendar, PenLine, Heart, Cloud, Target,
  type LucideIcon,
} from 'lucide-react';

export interface NavItemDef {
  id:           string;
  to:           string;
  label:        string;   // i18n key or plain label
  glyph?:       string;
  Icon?:        LucideIcon;
  defaultOrder: number;
}

export const ALL_NAV_ITEMS: NavItemDef[] = [
  { id: 'dashboard',         to: '/dashboard',         label: 'nav.dashboard',    glyph: '☉',  defaultOrder: 0  },
  { id: 'forecast',          to: '/forecast',          label: 'nav.forecast',     glyph: '☾',  defaultOrder: 1  },
  { id: 'agenda',            to: '/agenda',            label: 'nav.agenda',       Icon: Calendar, defaultOrder: 2  },
  { id: 'questions',         to: '/questions',         label: 'nav.questions',    Icon: PenLine,  defaultOrder: 3  },
  { id: 'birth-chart',       to: '/birth-chart',       label: 'nav.birthChart',   glyph: '⊙',  defaultOrder: 4  },
  { id: 'synastry',          to: '/synastry',          label: 'nav.synastry',     Icon: Heart,    defaultOrder: 5  },
  { id: 'numerology',        to: '/numerology',        label: 'nav.numerology',   glyph: '#',  defaultOrder: 6  },
  { id: 'astromatch',        to: '/astromatch',        label: 'nav.astromatch',   glyph: '≈',  defaultOrder: 7  },
  { id: 'tarot',             to: '/tarot',             label: 'nav.tarot',        glyph: '≡',  defaultOrder: 8  },
  { id: 'i-ching',           to: '/i-ching',           label: 'nav.iChing',       glyph: '∴',  defaultOrder: 9  },
  { id: 'dream-journal',     to: '/dream-journal',     label: 'nav.dreamJournal', Icon: Cloud,    defaultOrder: 10 },
  { id: 'astro-coach',       to: '/astro-coach',       label: 'nav.astroCoach',   Icon: Target,   defaultOrder: 11 },
  { id: 'empresas',          to: '/empresas',          label: 'nav.empresas',     glyph: '☆',  defaultOrder: 12 },
  { id: 'quiromancy',        to: '/quiromancy',        label: 'nav.quiromancy',   glyph: '∩',  defaultOrder: 13 },
  { id: 'astro-journal',     to: '/astro-journal',     label: 'Astro Journal',    glyph: '◇',  defaultOrder: 14 },
  { id: 'rota-profissional', to: '/rota-profissional', label: 'nav.startAstral',  glyph: '→',  defaultOrder: 15 },
  { id: 'lenormand',         to: '/lenormand',         label: 'nav.lenormand',    glyph: '♦',  defaultOrder: 16 },
  { id: 'astrocartografia', to: '/astrocartografia',  label: 'nav.astrocartografia', glyph: '⊕', defaultOrder: 17 },
  { id: 'retrogrado',       to: '/retrograde-radar',  label: 'Astros retrógrados',   glyph: '℞', defaultOrder: 18 },
  { id: 'eclipses',         to: '/eclipses',          label: 'nav.eclipses',         glyph: '◑', defaultOrder: 19 },
  { id: 'human-design',     to: '/human-design',      label: 'nav.humanDesign',      glyph: '⬡', defaultOrder: 20 },
  { id: 'vedic-astrology',  to: '/vedic-astrology',   label: 'nav.vedicAstrology',   glyph: '✶', defaultOrder: 21 },
  { id: 'astro-pet',        to: '/astro-pet',          label: 'nav.astroPet',         glyph: '♆', defaultOrder: 22 },
];
